"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionType = void 0;
var ActionType;
(function (ActionType) {
    ActionType["SetIsAnimating"] = "SET_IS_ANIMATING";
    ActionType["SetImageWidth"] = "SET_IMAGE_WIDTH";
    ActionType["SetImageLeft"] = "SET_IMAGE_LEFT";
    ActionType["SetImageHeight"] = "SET_IMAGE_HEIGHT";
})(ActionType || (exports.ActionType = ActionType = {}));
